import Button from '@/common/components/base/button/Button';
import { ResultOfInquiryModalType } from '@/common/components/base/inquiryPlate/modals/ResultOfInquiryModal.type';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';
import ShowIncidentParticipantsDataCard from '@/common/components/showIncidentParticipantsDataCard/ShowIncidentParticipantsDataCard';

const ResultOfInquiryModal = ({
  data,
  ResultHandler,
  onCloseModal,
}: ResultOfInquiryModalType) => {
  const mappedData = [
    { label: 'نوع خودرو:', value: data?.vehicle_type?.fa_name },
    { label: 'سیستم و تیپ:', value: data?.vehicle_model?.name },
    { label: 'مورد استفاده:', value: data?.vehicle_use?.name },
    { label: 'سال ساخت:', value: data?.vehicle_manufacturing_year },
    { label: 'رنگ خودرو:', value: data?.vehicle_color?.name },
    { label: 'تعداد سرنشین:', value: data?.vehicle_seat },
    { label: 'تعداد سیلندر:', value: data?.vehicle_cylinder },
    { label: 'شماره VIN:', value: data?.vehicle_vin },
    { label: 'شماره شاسی:', value: data?.vehicle_chassis },
    { label: 'شماره موتور:', value: data?.vehicle_engine },
  ];
  const confirmHandler = () => {
    ResultHandler?.(data);
    onCloseModal();
  };
  return (
    <Box display="flex" flexDirection="column" gap="16px">
      <TitleDescription
        className={css({
          marginBottom: '24px',
        })}
      >
        نتیجه استعلام بیمه مرکزی
      </TitleDescription>
      <ShowIncidentParticipantsDataCard data={mappedData} title="" />
      <Box
        width="100%"
        display="flex"
        justifyContent="space-between"
        gap="10px"
        mt="10px"
      >
        <Button
          onClick={onCloseModal}
          type="reset"
          variant="outlined"
          color="common"
          width="50%"
        >
          ثبت دستی اطلاعات
        </Button>
        <Button width="50%" onClick={confirmHandler}>
          تائید و ادامه
        </Button>
      </Box>
    </Box>
  );
};

export default ResultOfInquiryModal;
